<div mat-dialog-title class="text-xl font-bold">Restrict {{ driverName }}</div>
<hr class="mt-1 mb-1" />
<div mat-dialog-content>
  <div class="flex items-center gap-2 mb-3">
    <mat-icon>search</mat-icon>
    <mat-form-field class="w-full">
      <input matInput type="text" placeholder="Search Site" autofocus [formControl]="siteSearchControl" />
    </mat-form-field>
  </div>
  <div class="max-h-60 overflow-y-auto">
    <form [formGroup]="restrictionForm">
      <div class="select-all" (click)="toggleSelectAll()">
        {{ selectAllText }}
      </div>
      <div *ngFor="let site of filteredSites" class="flex flex-col gap-1 py-1">
        <mat-checkbox [formControlName]="'site-' + site.id">{{ site.name }}</mat-checkbox>
        <mat-form-field
          appearance="outline"
          class="reason-input"
          [class.hidden]="!restrictionForm.get('site-' + site.id)?.value"
        >
          <mat-label>Reason for Suspension</mat-label>
          <input
            matInput
            placeholder="Reason for suspension"
            [formControlName]="'reason-' + site.id"
            autocomplete="off"
          />
        </mat-form-field>
      </div>
    </form>
  </div>
</div>
<div class="flex justify-end mt-1" mat-dialog-actions>
  <button mat-button (click)="onCancelClick()">Cancel</button>
  <button mat-flat-button color="primary" [disabled]="restrictionForm.invalid" (click)="onAddRestriction()">Add</button>
</div>
